import React from 'react'
import {
  compose,
  withStateHandlers,
  branch,
} from 'recompose'
import { connect } from 'react-redux'
import { getFormValues } from 'redux-form'

import isEmpty from 'lodash/isEmpty'
import * as R from 'ramda'

import { IssueLinkCollapseWidget } from './IssueLinkCollapseWidget'
import { ISSUE_LINK_SYSTEM_TYPE } from './constants'
import { withEsuzIssueOnForm } from './withEsuzIssue'
import { withToirIssueOnForm } from './withToirIssue'

const formEnhancer = compose(
  connect((state, { form }) => ({
    issueLinkId        : R.prop(`esuz`, getFormValues(form)(state)),
    issueLinkSystemType: R.prop(`esuzSystemType`, getFormValues(form)(state)),
  })),
  branch(
    ({ issueLinkId, issueLinkSystemType }) => issueLinkId && issueLinkSystemType,
    compose(
      withStateHandlers({
        issueLink: {},
      }, {
        setIssueLinkData: () => (issueLink) => ({ issueLink }),
      }),
      branch(
        ({ issueLinkSystemType }) => issueLinkSystemType === ISSUE_LINK_SYSTEM_TYPE.ahp,
        withEsuzIssueOnForm,
      ),
      branch(
        ({ issueLinkSystemType }) => issueLinkSystemType === ISSUE_LINK_SYSTEM_TYPE.toir,
        withToirIssueOnForm
      )
    )
  ),

)


const IssueLinkFormWidget = ({
  issueLink,
  issueLinkSystemType,
}) => {
  if (!isEmpty(issueLink)) {
    return (
      <IssueLinkCollapseWidget issueLinkSystemType={issueLinkSystemType} issueLink={issueLink} />
    )
  }
  return null
}


export default formEnhancer(IssueLinkFormWidget)
